import { ProductReviewsResponse } from 'ui/helpers/formatReviews'

import { logger } from '@/helpers/logger'

const REVIEWS_API_URL = `${process.env.NEXT_PUBLIC_REVIEWS_API_URL}/product/review`
// Only the rating summary (stats) is needed here, not the review texts, so a single
// review per page is enough to keep the request cheap for product listing pages.
const REVIEWS_RATING_API_PARAMS = {
  store: process.env.NEXT_PUBLIC_REVIEWS_STORE,
  keyword: 'a',
  type: 'product_review',
  per_page: '1',
  page: '1',
  sort: 'helpful_desc',
}
const REVIEWS_REVALIDATE_SECONDS = 3600

export type ProductReviewRatings = {
  reviewsScore?: number
  reviewsCount?: number
}

export const fetchProductReviewRatings = async (sku: string): Promise<ProductReviewRatings> => {
  if (!sku) return {}

  try {
    const params = new URLSearchParams({ ...REVIEWS_RATING_API_PARAMS, sku })
    const response = await fetch(`${REVIEWS_API_URL}?${params.toString()}`, {
      next: { revalidate: REVIEWS_REVALIDATE_SECONDS },
    })

    if (!response.ok) {
      throw new Error(`Reviews API responded with ${response.status}`)
    }

    const { stats }: ProductReviewsResponse = await response.json()

    if (!stats.count) return {}

    return {
      reviewsScore: parseFloat(parseFloat(stats.average).toFixed(1)),
      reviewsCount: stats.count,
    }
  } catch (error) {
    logger.error('Product Card > Review Ratings', sku, error)
    return {}
  }
}
